 

export default{ 
    data() {
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'议题申请列表', path:'/oa/meeting/sign'
            },{
                name:'议题申请详情', path:''
            }],
            apis:{//接口列表  
                save:'oa/sign/save',//保存
                bykey:'oa/sign/byKey',//详情 
                getFileNum:'oa/fn/cfg/getFileNum',
                roomList:'/oa/meeting/room/all',
                getNum:'/oa/sign/getNum',
                motionList: 'oa/motion/list',//获取列表
                signDetailList:'/oa/signDetail/all',//报签明细列表
                signDetailSave:'/oa/signDetail/save',//保存报签明细
                delSignDetail:'/oa/signDetail/del'//删除报签明细
            }, 
            editObj:{
                title:"",
                fileKey:"", 
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"",
            fileList:[],//源文件  
            rooms:[],
            drawer:false,
            motionData:[],
            signDetailData:[],
            dialogFormVisible:false,
            motionObj:{
                seq:1,
                isVote:0
            },
            motionRules:{
                motionName:[{ required: true, message: '请选择议题', trigger: 'blur' }],
                seq:[{ required: true, message: '请输入排序号', trigger: 'blur' }],
            },
            motionTableDialog:false,
            params:{
                page:1,
                limit:20, 
            },
            total:0,
            selectData:[]
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        bizKey: String,
    },
    
    watch: {
        bizKey() {
            this.find();
        }, 
    }, 
    mounted() {  
        this.find(); 
    },                                        
    methods: {
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params:me.key
            }).then(rsp => {
                if(rsp.success){
                    me.editObj=rsp.retObj;
                   
                }
            })
        },  
        goBack(){ 
            this.$router.go(-1);
        }, 
        editDoc(){
           WebCtrl.ShowPage();
        }, 
        chooseMotion(){
            this.loadMotion();
        },
        pageChange(v){
            const me = this;
            me.$set(me.params, 'page', v);
            me.loadMotion();
        },
        sizeChange(v){
            const me = this;
            me.$set(me.params, 'limit', v);
            me.loadMotion();
        },
        showDrawer(){
            if(this.key==-1){
                this.$message({
                    message: '请先保存议题报签数据!',
                    type: 'error'
                });  
                return;
            }
            this.loadSignDetail();
        },
        loadSignDetail(){ 
            const me=this;
            me.$post({
                url: me.apis.signDetailList,
                params: me.key
            }).then(rsp => { 
                me.signDetailData=rsp.retObj;
                this.drawer=true
            })
        },
        loadMotion(){ //加载议题列表
            const me=this;
            me.$post({
                url: me.apis.motionList,
                params: me.params
            }).then(rsp => {
                me.total=rsp.total;
                me.motionData=rsp.retList;
                me.motionTableDialog=true;
            })
        },
        handleSelectionChange(val) { //议题选择
            this.selectData = val;
        }, 
        addSignDetail(){
            this.motionObj={
                seq:1,
                isVote:0
            };
            this.dialogFormVisible=true;
            
        }, 
        editDetail(row){
            this.motionObj=JSON.parse(JSON.stringify(row));
            this.dialogFormVisible=true; 
        },
        delDetail(){
            this.$post({
                url: this.apis.delSignDetail,
                params: {key:row.id}
            }).then(rsp => {
               this.loadSignDetail();
            })

        },
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/meeting/sign/view/view.js